import Vue from 'vue'

/*
* Checks if a webpage is up
* @param {String} url
* @return Boolean
*/
export async function doesSiteExist (url) {
  let response
  try {
    response = await Vue.http.get(url)
  } catch (e) {
    console.log('error', e, response)
    return false
  }

  if (response && response.status === 200) {
    return true
  } else {
    return false
  }
}

/*
* Checks if the page that this function is called from is retired/deprecated.
* If yes, redirects to the new frontend with a querystring containing instances
*/
export function checkForOldFrontend () {
  const oldFrontend = 'app.sigmacloud.io'
  const newFrontend = 'https://probooks.revolutiones.com'
  /* To help testing, have two sigma-frontend instances listening on ports 8080 and 8081:
  const oldFrontend = 'localhost:8080'
  const newFrontend = 'http://localhost:8081'
  */
  if (window.location.host === oldFrontend) {
    // console.log('Old Location. Redirecting')
    let currentInstances
    try {
      currentInstances = JSON.parse(localStorage.getItem('instances') || [])
    } catch (e) {
      console.log('error', e)
    }
    const safeString = encodeURIComponent(JSON.stringify(currentInstances.map((i) => i.url)))
    window.location.href = newFrontend + '/login?loadInstances=' + safeString
  } else {
    return null
  }
}

/*
* Checks if a particular query string is passed in that contains a list of instances.
* If yes, it will add them (if necessary) to localStorage.instances
* @param {String} querystring
* @param {Object} store of the vuex store
* @return Boolean
*/
export function checkForInstances (querystring, store) {
  const load = (querystring.hasOwnProperty('loadInstances')) ? querystring.loadInstances : null
  if (load && typeof load === 'string') {
    let instancesToImport
    try {
      instancesToImport = JSON.parse(decodeURIComponent(load))
    } catch (e) {
      console.log('error', e)
    }
    if (instancesToImport && instancesToImport.length) {
      const existingInstances = JSON.parse(localStorage.getItem('instances') || [])
      const existingUrls = existingInstances ? existingInstances.map((i) => i.url) : []
      for (const i in instancesToImport) {
        if (existingUrls.indexOf(instancesToImport[i]) >= 0) {
          // console.log('Not adding ' + instancesToImport[i])
        } else {
          // console.log('Adding ' + instancesToImport[i])
          store.dispatch('addInstance', instancesToImport[i])
        }
      }
    }

    return true
  } else {
    return false
  }
}

/*
* During login, will check if an instance has been moved from the old domain and will update
* the localStorage.instances list.  Uses mutation-style parameters to match existing code.
* @param {String} payload
* @param {Object} state
* @returns String (the new instance URL if conditions are meet)
*/
export async function checkForMigratedInstance (payload, state) {
  const oldDomain = 'sigmacloud.io'
  const newDomain = 'pa.revolutiones.com'
  const oldDomainPattern = new RegExp(oldDomain)
  const oldURL = payload.url && payload.url.match(oldDomainPattern)

  if (!oldURL) {
    return null
  } else {
    const newURL = payload.url.replace(oldDomainPattern, newDomain)
    if (await doesSiteExist(oldURL.input) === false && await doesSiteExist(newURL) === true) {
      // console.log('Switching ' + oldURL.input + ' to ' + newURL)
      let targetInstance = state.instances.find(instance => instance.url === oldURL.input)
      targetInstance.url = newURL
      localStorage.setItem('instances', JSON.stringify(state.instances))
      return newURL
    }

    return null
  }
}



// WEBPACK FOOTER //
// ./src/utils/helpers/SigmacloudRetiring.js